import React, { Component } from 'react';
import { Form, Field } from 'redux-form';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ButtonStandardPrimary from 'components/atoms/buttons/standard/Primary';
import FormHeading from 'components/atoms/form/FormHeading';
import TextInputAdmin from 'components/atoms/inputs/TextInputAdmin';
import FormSubHeading from 'components/atoms/form/FormSubHeading';
import CapabilitySelectContainer from 'containers/CapabilitySelectContainer';

const CancelButton = styled(Button) `
    margin: 0 10px;
    padding: 0px 25px;
    font-size: 16px;
    height: 48px;
`;

class EditCapabilityGroupForm extends Component {
    renderHeading() {
        if (this.props.capabilityGroup) {
            return (
                <FormHeading>Edit Capability Group:&nbsp;
                    {this.props.capabilityGroup &&
                        <span>
                            {this.props.capabilityGroup.name}
                        </span>
                    }
                </FormHeading>
            );
        }

        return (
            <FormHeading>Create New Capability Group</FormHeading>
        );
    }

    render() {
        return (
            <Form onSubmit={this.props.handleSubmit()} id="editCapabilityGroupForm">
                <Grid fluid>
                    {this.renderHeading()}
                    <Row>
                        <Col md={6}>
                            <FormSubHeading>Name</FormSubHeading>
                            <Field component={TextInputAdmin} name="name" label="Name" type="text" />

                            <FormSubHeading>Capabilities</FormSubHeading>
                            <Field name="Capabilities" component={CapabilitySelectContainer} />
                        </Col>
                    </Row>

                    <br/>

                    <ButtonStandardPrimary type="submit">Submit</ButtonStandardPrimary>
                    <CancelButton onClick={this.props.cancel} type="reset" bsStyle='link' >Cancel</CancelButton>
                </Grid>
            </Form>
        );
    }
}

EditCapabilityGroupForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    capabilityGroup: PropTypes.object,
    cancel: PropTypes.func.isRequired,
};

export default EditCapabilityGroupForm;



// WEBPACK FOOTER //
// ./src/components/organisms/forms/EditCapabilityGroup.js